import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { ConfirmAction, Icon } from "MODULES/shared/components";
import { reserveForRepair } from "MODULES/inventories/actions";
import { ID } from "APP_ROOT/constants";

function ReserveForRepair({ editing, close, update, inventory }) {
  const isBrokered = inventory && inventory.get("brokered_exchange");

  return (
    <ConfirmAction
      onConfirm={update}
      close={close}
      open={editing}
      icon={<Icon name="wrench" fixed />}
      btnText="Reserve"
    >
      <strong>Heads up!</strong> &nbsp;
      <span>Are you sure you&apos;d like to reserve this item for repair?</span>
      {isBrokered && (
        <p style={{ color: "red", marginTop: "1rem" }}>
          NOTE: This unit is from a Brokered Exchange Transaction
        </p>
      )}
    </ConfirmAction>
  );
}

ReserveForRepair.propTypes = {
  editing: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  update: PropTypes.func.isRequired,
  inventory: PropTypes.shape({
    get: PropTypes.func
  })
};

export default connect(undefined, (dispatch, ownProps) => ({
  update: () =>
    dispatch(reserveForRepair(ownProps.inventory && ownProps.inventory.get(ID)))
}))(ReserveForRepair);



// WEBPACK FOOTER //
// ./app/modules/inventories/components/Detail/Header/DropdownActions/ReserveForRepair/ReserveForRepair.jsx